import { useTranslation } from "@/hooks/useTranslation";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeleteEventDialogProps {
  open: boolean;
  /** Paid events also say that the purchase stays with the event. */
  isPaid: boolean;
  busy: boolean;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
}

/**
 * JUB-157: deleting an event moves it to the Trash for 30 days (approved copy).
 */
export function DeleteEventDialog({ open, isPaid, busy, onConfirm, onOpenChange }: DeleteEventDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="delete-event-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("events.deleteDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription data-testid="delete-event-dialog-text">
            {t("events.deleteDialog.description")}
            {isPaid && <> {t("events.deleteDialog.purchaseKept")}</>}
          </AlertDialogDescription>
          <p className="text-sm text-muted-foreground">{t("events.deleteDialog.afterWindow")}</p>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={busy}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            data-testid="confirm-delete-event-button"
          >
            {busy ? t("common.loading") : t("events.deleteDialog.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
